var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37862 1.63867H2.48475C2.03813 1.63867 1.60981 1.81609 1.294 2.13189C0.978198 2.4477 0.800781 2.87602 0.800781 3.32264V15.1104C0.800781 15.557 0.978198 15.9853 1.294 16.3011C1.60981 16.6169 2.03813 16.7944 2.48475 16.7944H14.2725C14.7191 16.7944 15.1474 16.6169 15.4632 16.3011C15.779 15.9853 15.9565 15.557 15.9565 15.1104V9.21651",
    stroke: "#08478C",
    strokeWidth: 1.59946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 1.32295C14.0856 0.987984 14.5399 0.799805 15.0136 0.799805C15.4873 0.799805 15.9416 0.987984 16.2766 1.32295C16.6116 1.65791 16.7997 2.11221 16.7997 2.58592C16.7997 3.05963 16.6116 3.51393 16.2766 3.84889L8.68781 11.4385C8.48788 11.6383 8.24089 11.7845 7.9696 11.8637L5.55059 12.571C5.47814 12.5921 5.40134 12.5934 5.32823 12.5747C5.25512 12.5559 5.18839 12.5179 5.13502 12.4645C5.08166 12.4112 5.04362 12.3444 5.02489 12.2713C5.00616 12.1982 5.00743 12.1214 5.02856 12.049L5.73582 9.62994C5.81541 9.35887 5.96192 9.11217 6.16187 8.91257L13.7507 1.32295Z",
    stroke: "#08478C",
    strokeWidth: 1.59946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTextIcon);
export default __webpack_public_path__ + "static/media/edit-text-icon.ceb4d696156c1eef2442c84fd13a4202.svg";
export { ForwardRef as ReactComponent };